// extracted by mini-css-extract-plugin
export var carousel = "styles-module--carousel--0420a";
export var desktop = "1340px";
export var diables = "styles-module--diables--b6be7";
export var fullSpace = "styles-module--fullSpace--054aa";
export var giant = "2200px";
export var heading = "styles-module--heading--b324a";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var navButton = "styles-module--navButton--cec73";
export var pagination = "styles-module--pagination--ee40c";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var styles = "styles-module--styles--4c171";
export var tablet = "769px";
export var titleAndControls = "styles-module--titleAndControls--a62be";